import React from "react"
import {Box as MUIBox} from "@mui/material"
import {formatTextTestIds} from "@next/utils"
import {Box, Tab, Chip, Tabs, Title, Wrapper, Container} from "./component"
import TabsScrollButton from "../TabsScrollButton"
import {Content} from "../../models/secondary-nav"
import {configRelativePathURL} from "../../utils/configUrlPath"

type ChipsContainerProps = {
    personalisationContent: Content[]
    siteUrl: string
}

export const ChipsContainer = ({personalisationContent, siteUrl}: ChipsContainerProps) => {
    const handleOnChipClick = (target: string) => {
        const path = configRelativePathURL(target, siteUrl)
        window.location.href = path
    }

    return (
        <MUIBox data-testid="header-chips-container">
            <Wrapper>
                <Container>
                    {personalisationContent.map(content => {
                        const {title} = content
                        return (
                            <Box key={title}>
                                {title && <Title data-testid="header-chips-container-title">{title}</Title>}
                                <Tabs
                                    variant="scrollable"
                                    value={false}
                                    scrollButtons="auto"
                                    ScrollButtonComponent={TabsScrollButton}
                                >
                                    {content?.items.length > 0 &&
                                        content.items.map(data => {
                                            return (
                                                <Tab
                                                    key={data?.title}
                                                    label={
                                                        <Chip
                                                            data-testid={formatTextTestIds(
                                                                `header-chips-container-chip-${data?.title}`,
                                                            )}
                                                            variant="outlined"
                                                            label={data.title}
                                                            onClick={() => handleOnChipClick(data?.target)}
                                                        />
                                                    }
                                                />
                                            )
                                        })}
                                </Tabs>
                            </Box>
                        )
                    })}
                </Container>
            </Wrapper>
        </MUIBox>
    )
}

export default ChipsContainer
